import {
  AfterViewInit,
  Component,
  ElementRef,
  EventEmitter,
  Input, OnDestroy,
  OnInit,
  Output,
  ViewChild
} from "@angular/core";
import {IEnumListEntry} from "../../definitions";
import {WatchService} from "../../services/watch.service";
import {DEF_INPUT_SIZE} from "../../enums/enums";
import {BusService, INewDocumentEvent} from "../../services/bus.service";
import {Subject} from "rxjs/Subject";
import {IDocument} from "../../interfaces/document.definition";
declare const $:any;


@Component({
  selector: "nv-select",
  templateUrl: "./nv-select.component.html"
})
export class NvSelectComponent implements OnInit, AfterViewInit, OnDestroy {
  private unsubscribe: Subject<void> = new Subject<void>();
  private lastNewDocumentEvent: INewDocumentEvent;

  _label: string;
  _size: number;
  _multiple: boolean = false;

  @Input() ignoreDocumentReadonlyFlag: boolean = false;
  @Input() hideLabel: boolean = false;
  @Input() callback: () => void;
  @Input() options: IEnumListEntry[];
  @Input() document: any;
  @Input() prop: string;
  @Input() valueProp: string = "id";
  @Input() displayLabel: string = "label";
  @Input() displayLabelFunction: (doc:IDocument) => string;

  @Input() set label(v: string) { this._label = v; }
  @Input() set size(v: number) { this._size = v; }
  @Input() set multiple(v: boolean) { this._multiple = v; }

  get label(): string { return this._label || this.prop; }
  get size(): number { return this._size || DEF_INPUT_SIZE; }
  get multiple(): boolean { return this._multiple; }

  @Output() update = new EventEmitter();

  @ViewChild("selectNode") element: ElementRef;



  constructor(private watchService: WatchService,
              private busService: BusService) {
  }


  ngOnInit(): void {
    this.busService
      .onDocumentUpdated
      .takeUntil(this.unsubscribe)
      .subscribe(e => this.onDocumentUpdated(e));
  }


  ngAfterViewInit(): void {
    this.updateNodeState();
  }


  ngOnDestroy(): void {
    this.unsubscribe.next();
    this.unsubscribe.complete();
  }


  onChage() {
    this.watchService.notify();
    this.update.emit();
  }


  private updateNodeState() {
    if (this.ignoreDocumentReadonlyFlag) { return; }
    if (!this.element) { return; }

    if (this.lastNewDocumentEvent.readonly) {
      $(this.element.nativeElement).prop("disabled", true);
    } else {
      $(this.element.nativeElement).prop("disabled", false);
    }
  }


  private onDocumentUpdated(e: INewDocumentEvent) {
    this.lastNewDocumentEvent = e;
    this.updateNodeState();
  }
}



// WEBPACK FOOTER //
// /opt/app/develop/src/app/components/nv-select/nv-select.component.ts